import React, { useEffect, useRef } from 'react';
import { GroupBase, MenuListProps } from 'react-select';
import { Virtuoso, VirtuosoHandle } from 'react-virtuoso';

import { DropdownOption } from '../../DropdownInput/typings';

const InnerItem = React.memo(({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
});

InnerItem.displayName = 'VirtuosoMenuList.InnerItem';

const OPTION_HEIGHT = 37;
const getListHeight = (totalOptions: number, maxDisplayOptions: number) => {
  return totalOptions < maxDisplayOptions ? totalOptions * OPTION_HEIGHT : maxDisplayOptions * OPTION_HEIGHT;
};

const VirtuosoMenuList = <
  Option = DropdownOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  options,
  children,
  getValue,
  maxDisplayOptions = 6,
}: MenuListProps<Option, IsMulti, Group> & { maxDisplayOptions?: number; borderColor?: string }) => {
  const virtuosoRef = useRef<VirtuosoHandle>(null);
  const [option] = getValue();
  useEffect(() => {
    if (virtuosoRef?.current) {
      let selectedOptionIndex = 0;

      if (option) {
        selectedOptionIndex = options.findIndex(
          (item) => (item as DropdownOption).value === (option as unknown as DropdownOption).value,
        );
      }
      setTimeout(() => {
        virtuosoRef.current?.scrollToIndex({
          index: selectedOptionIndex,
          align: 'start',
          behavior: 'auto',
        });
      }, 0);
    }
  }, [option, options]);

  return Array.isArray(children) ? (
    <Virtuoso
      ref={virtuosoRef}
      overscan={{ main: 12, reverse: 12 }}
      style={{
        height: `${getListHeight(children.length, maxDisplayOptions)}px`,
        borderRadius: '0.25rem',
      }}
      totalCount={children.length}
      itemContent={(index) => <InnerItem>{children[index]}</InnerItem>}
    />
  ) : (
    <div>{children}</div>
  );
};

export default VirtuosoMenuList;
